import { resolvePackageState, IMPORTANT_STATUSES } from 'constants/package-statuses';
import { PACKAGE_TYPES } from 'constants/package-types';
import { PACKAGE_NAME_MAP } from 'constants/package-name-map';


const FULL_NOTIFICATION_STATES = new Set(['Started', 'Completed']);

export const formatPackageMessage = (data) => {
    if (!data) return null;

    const { type, state, id, name } = data;

    if (!type || !state || id == null) return null;

    const stateLabel = resolvePackageState(state);
    if (!stateLabel) return null;
    if (!IMPORTANT_STATUSES.has(stateLabel)) return null;

    const packageName = PACKAGE_NAME_MAP[type];
    if (!packageName) return null;

    const onlyNotify = !(
        type === PACKAGE_TYPES.LIVE_TRADING &&
        FULL_NOTIFICATION_STATES.has(stateLabel)
    );

    return {
        userid: id,
        messageId: id,
        title: `Opportrade - ${packageName.toUpperCase()} ${stateLabel.toLowerCase()}`,
        text: `Your ${packageName} ${name ?? ''} has ${stateLabel.toLowerCase()}!`,
        timestamp: new Date().toISOString(),
        isRead: false,
        onlyNotify
    };
};
